module.exports = __webpack_public_path__ + "static/img/129.3ef220a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/129.jpg
// module id = x3pm
// module chunks = 0